import { CookieBanner } from './CookieBanner.js';
if (!customElements.get('zz-cookie-banner')) {
    customElements.define('zz-cookie-banner', CookieBanner);
}
